import React from 'react';
import PropTypes from 'prop-types';
import { Type, Upload, Video } from 'react-feather';
import ResponseButton from '../../shared/ResponseButton';
import { getUgcSettings } from './getUgcSettings';
import BlockLabel from '../../shared/BlockLabel';

function UgcSelector(props) {
  const {
    ugcTypes,
    browserSupportsWebcam,
    hasAttachedMedia,
    mediaResponsePath,
    textResponsePath,
    askLabel,
  } = props;
  const {
    ugcTextOnly,
    ugcUploadOnly,
    ugcVideoOnly,
    hasVideo,
    hasUpload,
    hasText,
  } = getUgcSettings(ugcTypes);

  const VideoResponseButton = () => (
    <ResponseButton
      href={mediaResponsePath}
      Icon={() => <Video className="button-icon--flex-element" />}
      text="VIDEO"
      data-testid="UgcSelector/VideoResponseButton"
    />
  );

  const UploadResponseButton = () => (
    <ResponseButton
      text="UPLOAD"
      Icon={() => <Upload className="button-icon--flex-element" />}
      data-testid="UgcSelector/UploadResponseButton"
    />
  );

  const TextResponseButton = () => (
    <ResponseButton
      href={textResponsePath}
      text="TEXT"
      Icon={() => <Type className="button-icon--flex-element" />}
      data-testid="UgcSelector/TextResponseButton"
    />
  );

  const Title = () => {
    if (ugcUploadOnly) {
      return null;
    }

    return (
      <div data-testid="UgcSelector/Title">
        <BlockLabel askLabel={askLabel} />
      </div>
    );
  };

  if (!browserSupportsWebcam && ugcVideoOnly) {
    return (
      <>
        <Title />
        <div className="ugc-selector">
          <UploadResponseButton />
        </div>
      </>
    );
  }

  if (ugcTextOnly && hasAttachedMedia) {
    return (
      <a
        className="fake-input-as-button"
        href={textResponsePath}
        data-target="upload-response-file.ugcTextButton"
        data-testid="UgcSelector/FakeInputAsButton"
      >
        Enter your response...
      </a>
    );
  }

  return (
    <>
      {(!ugcTextOnly || !ugcUploadOnly) && <Title />}
      <div className="ugc-selector">
        {hasVideo && browserSupportsWebcam && <VideoResponseButton />}
        {hasUpload && <UploadResponseButton />}
        {hasText && <TextResponseButton />}
      </div>
    </>
  );
}

UgcSelector.propTypes = {
  browserSupportsWebcam: PropTypes.bool.isRequired,
  ugcTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  mediaResponsePath: PropTypes.string.isRequired,
};

export default UgcSelector;
